import { h } from 'preact'
import Icon, { IconType } from '../../assets/'
import { ComponentChildren } from 'preact'

interface Props {
  icon: IconType,
  children: ComponentChildren,
  href: string,
}

const SearchActionLink = ({children, href, icon}: Props) => <a className='link algolia-search__action' href={href}>
  <Icon color='currentColor' customClass='algolia-search__action-icon' icon={icon} height={20} width={20} />
    <span class='algolia-search__action-link'>
    {children}
  </span>
</a>

export default SearchActionLink
